import React from "react";
import {
	Button,
	Container,
	Grid,
	Toolbar,
	Typography,
	Alert,
	colors,
} from "@mui/material";
import WorkIcon from "@mui/icons-material/Work";
import { useEffect, useState } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Table from "../offers/Table";
import { Widget } from "../../components/widget/Widget";
import CollectionDilogbox from "./CollectionDilogbox";
import { Margin, Visibility } from "@mui/icons-material";
import CollectionDetails from "./CollectionDetails";
import EditCollection from "./EditCollection";
import { useDispatch, useSelector } from "react-redux";
import { showLoading } from "../../redux/actions/collection.actions.";
import CommonShimmer from "../../components/comman/shimmerTable/ShimmerTable";
import TotalCard from "../../components/comman/cards/TextCards";
import { toast } from "react-hot-toast";
import CommonDataTable from "../../components/comman/comman-table/newTable";
import CreateCampaignCard from '../campaigns/component/CardComponent';
import { fetchFilteredCollections } from "../../redux/actions/collectionsFilter.actions";
import useDebounce from "../../hooks/useDebounce";
import { motion } from "framer-motion";
import "./collection.scss";



const Collection = () => {
	const host = `${process.env.REACT_APP_BASE_URL_VMS}`;
	const [open, setOpen] = useState(false);
	const [hoveredRow, setHoveredRow] = useState(null);
	const [offers, setOffers] = useState([]);
	const [newCollection, setnewCollection] = useState([]);
	const [openClcDet, setopenClcDet] = React.useState(false);
	const [brands, setBrands] = useState([]);
	const [cdeatilsid, setCdeatilsid] = useState("");
	const [alertMessage, setAlertMessage] = useState("");
	const [alertType, setAlertType] = useState("Success");
	const [openEdit, setOpenEdit] = useState(false);
	const [openAlert, setOpenAlert] = useState(false);
	const [alertMsg, setAlertMsg] = useState("");
	const { user } = useSelector((state) => state.authReducer);
	const { loading } = useSelector((state) => state.collectionReducer);
	const { pagination, collections } = useSelector((state) => state?.collectionFilterReducer);
	const [collectionDetails, setCollectionDetails] = useState([]);
	const [selectColId, setSelectedColId] = useState("");
	const [page, setPage] = useState(1);
	const [compaignSearch, setCampaignForSearch] = useState('');




	const dispatch = useDispatch();
	const { user_roleid } = user;
	const handleClickOpen = () => {
		//getAllCollection();
		getAllBrands();
		fetchOffers();
		setOpen(true);
	};



	const handleOpen = (alert) => {
		openAlert(true);
		alertMessage(alert.message);
		setTimeout(() => {
			openAlert(false);
		}, 5000);
	};


	const handleClose = () => {
		setOpen(false);
	};


	const debouncedSearch = useDebounce(compaignSearch, 600);

	useEffect(() => {
		const filters = {};
		if (debouncedSearch) {
			filters.search = debouncedSearch;
			dispatch(fetchFilteredCollections(1, filters));
		}else{
			dispatch(fetchFilteredCollections(page, filters));
		}
	}, [debouncedSearch, page, dispatch]);

	const getAllBrands = async () => {
		dispatch(showLoading(true));
		const response = await fetch(`${host}/api/v1/source_business`, {
			method: "GET", // *GET, POST, PUT, DELETE, etc.
			headers: {
				"Content-Type": "application/json",
				'accessToken': localStorage.getItem('accessToken'),
			},
		});
		const json = await response.json();
		dispatch(showLoading(false));
		if (json.data != "") {
			setBrands(json);
		}
	};
	const fetchOffers = async () => {
		dispatch(showLoading(true));
		const response = await fetch(`${host}/api/v1/collections/offerings/`, {
			method: "GET", // *GET, POST, PUT, DELETE, etc.
			headers: {
				"Content-Type": "application/json",
				'accessToken': localStorage.getItem('accessToken'),
			},
		}).catch((err) => {
			console.log(err.mesage);
			dispatch(showLoading(false));
		});
		//setNote(response);

		const json = await response.json();
		dispatch(showLoading(false));

		setOffers(json);
	};


	const createCollection = async (data) => {
		dispatch(showLoading(true));
		let response = await fetch(`${host}/api/v1/collections/`, {
			method: "POST", // *GET, POST, PUT, DELETE, etc.
			headers: {
				"Content-Type": "application/json",
				'accessToken': localStorage.getItem('accessToken'),
			},
			body: JSON.stringify(data),
		}).catch((err) => {
			console.log(err.mesage);
			dispatch(showLoading(false));
		});
		if (response) {
			dispatch(showLoading(false));
			if (response.status === 200) {
				setAlertType("success");
				setAlertMessage("Collection created successfully!");
			} else {
				setAlertType("error");
				setAlertMessage("Unable to create collection!");
			}
			// getAllCollection();
			return 1;
		}
	};

	const editCollection = async (collectionId, data) => {
	};

	const editCollectionResult = async (data) => {
		dispatch(showLoading(false));
		if (data == "success") {
			setAlertType("success");
			// getAllCollection();
			fetchOffers();
			setAlertMessage("Collection updated successfully!");
		}
		else if (data == "error") {
			setAlertType("error");
			setAlertMessage("Unable to update collection!");
		}
	}



	const getCollectionDetails = async (id) => {
		dispatch(showLoading(true));
		const response = await fetch(`${host}/api/v1/collections/${id}`, {
			method: "GET", // GET, POST, PUT, DELETE, etc.
			headers: {
				"Content-Type": "application/json",
				'accessToken': localStorage.getItem('accessToken'),
			},
		}).catch((err) => {
			console.log(err.mesage);
			dispatch(showLoading(false));
		});
		const json = await response.json();
		dispatch(showLoading(false));
		setCollectionDetails(json);
	};

	const handleDetails = (id) => {
		const collectionId = id?.collection_id
		getCollectionDetails(collectionId);
		setopenClcDet(true);
	};
	const handleDelete = async (id) => {
		const response = await fetch(`${host}/api/v1/collections/${id?.collection_id}`, {
			method: "DELETE", // *GET, POST, PUT, DELETE, etc.
			headers: {
				"Content-Type": "application/json",
				'accessToken': localStorage.getItem('accessToken'),
			},
		});
		//const json= await response.json();

		if (response) {
			const data = await response.json();
			if (response.status === 200) {
				setAlertType("success");
				toast.success("Collection deleted successfully!");
				let collection = collections.filter((e) => {
					return e.collection_id !== id;
				});
				// setCollections(collection);
			} else {
				setAlertType("error");
				toast.error(data.msg || "Unable to delete collection!");
			}
		} else {
			setAlertType("error");
			toast.error("Unable to delete collection!");
			// setAlertMessage("Unable to delete collection!");
		}
	};

	const handleEdit = (id) => {
		// console.log("Handle", id);
		getCollectionDetails(id?.collection_id);
		editCollection(id, collectionDetails)
		getAllBrands();
		fetchOffers();
		// setOpen(true);
		setOpenEdit(true)
		setSelectedColId(id)
	}

	const handlePageChange = (newPage) => {
		setPage(newPage);
	};

	const column = [
		{ key: "collection_id", label: "Collection ID" },
		{ key: "collection_name", label: "Collection Name" },
		{ key: "details", label: "Details" },
	]


	return (
		<Container className='collection-management '>
			<Grid container direction='column' spacing={5} >
				<Grid item>
					<motion.div
						className="collection-management-intro"
						initial={{ opacity: 0, y: -16 }}
						animate={{ opacity: 1, y: 0 }}
						transition={{ duration: 0.45, ease: "easeOut" }}
					>
						<h2>Collection Management Overview</h2>
						<p>
							Create, edit, and organize collections with quick actions from a single view.
						</p>
					</motion.div>
				</Grid>
				<Grid
					container
					item
					direction='row'
					justifyContent=''
					gap={5}>
					<TotalCard text={`TOTAL COLLECTION: ${pagination?.pageSize}`} icons={<WorkIcon fontSize="medium" />} color={"#7469f1"} width={"350px"} />
				</Grid>
				<Grid item>
					{(user_roleid === 1 || user_roleid === 2 || user_roleid === 4 || user_roleid === 5) &&
						<CreateCampaignCard onClick={handleClickOpen} btnText={"Create Collection"} heading={"Collection"} />
					}
					{
						(collections) ?
							<div className="pt-10">
								<CommonDataTable
								data={collections}
								onView={handleDetails}
								onEdit={handleEdit}
								onDelete={handleDelete}
								currentPage={page}
								onPageChange={(newPage) => handlePageChange(newPage)}
								showSearch={true}
								totalPages={pagination?.totalPages}
								setCompaignForSearch={setCampaignForSearch}
								compaignSearch={compaignSearch}
								columns={column}
								searchText={`Search Collection ID and Collection Name....`}
							/>
							</div>
							:
							<CommonShimmer />
					}

				</Grid>
			</Grid>
			<CollectionDilogbox
				createCollection={createCollection}
				open={open}
				newCollection={newCollection}
				setnewCollection={setnewCollection}
				offers={offers}
				setOpen={setOpen}
				brands={brands}
				collections={collections}
			/>
			<EditCollection
				editSingleCollection={editCollection}
				openEdit={openEdit}
				selectColId={selectColId}
				offers={offers}
				setOpenEdit={setOpenEdit}
				brands={brands}
				collections={collections}
				collectionDetails={collectionDetails}
				editCollectionResult={editCollectionResult}
			/>

			<CollectionDetails
				open={openClcDet}
				setOpen={setopenClcDet}
				collectionDetails={collectionDetails}
			/>
		</Container>
	);
};
export default Collection;
